import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function confirmCancelGroupSession(bookingId) {
  if (!bookingId) {
    throw new Error("no booking id");
  }
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/group_timeslot_patient/groupsession_booking/confirm_cancel/${bookingId}`,
    {
      method: "POST",
    },
  );

  if (!res.ok) {
    throw new Error(
      `failed to confirm cancel appointment: ${getErrorDetail(
        await res.text(),
      )}`,
    );
  }

  return;
}
